import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import useWindowSize from "./utils/windowSize";
import "./App.css";
import GameScreen from "./pages/GameScreen/GameScreen";
import HomeScreen from "./pages/HomeScreen/HomeScreen";
import RedirectingScreen from "./pages/RedirectingScreen/redirectingScreen";
import NotFound from "./pages/404/404";
import SmallViewport from "./pages/SmallViewport/SmallViewport";
import OuterScreen from "./pages/OuterScreen/OuterScreen";
import EndScreen from "./pages/EndScreen/EndScreen";

function App() {
  const size = useWindowSize();
  const [displayWidth, setDisplayWidth] = useState(size.width);
  useEffect(() => {
    setDisplayWidth(size.width);
  }, [size]);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route
          path="/game"
          element={displayWidth > 768 ? <GameScreen /> : <SmallViewport />}
        />
        <Route path="/redirect" element={<RedirectingScreen />} />
        {/* <Route path="/attempt/:domain" element={<TestScreen />} /> */}
        <Route path="/outer" element={<OuterScreen />} />
        <Route path="/end" element={<EndScreen />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
